export { default as Result } from './Result/template';
